import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Chat Interfaces", desc: "Chat interfaces on any LLM, connected to customer-facing or internal business workflows." },
  { title: "RAG Pipelines", desc: "Your docs + AI answers with retrieval, context assembly, and grounded responses." },
  { title: "Assistive Writing", desc: "AI writing assistants, summary tools, and reply drafting inside your own product or internal systems." },
  { title: "AI Search", desc: "Search across your own knowledge base, documents, and records with faster retrieval and better context." },
];

const useCases = [
  ["Legal", "Contract Review AI — flags risky clauses"],
  ["Real Estate", "Property Q&A Bot from your listings"],
  ["Healthcare", "Patient FAQ Bot from hospital content"],
  ["E-Commerce", "AI Product Recommendation Engine"],
  ["HR", "Policy Helpdesk from your HR manual"],
  ["Finance", "Report Summariser — 50 pages in 30 seconds"],
];

const LlmIntegration = () => (
  <StitchFeaturePage
    label="SERVICE · LLM INTEGRATION"
    title="Your existing software,"
    titleAccent="now with a brain."
    subtitle="We integrate OpenAI, Claude, Gemini, or open-source models directly into your existing CRM, ERP, or app."
    features={features}
    badges={["OpenAI GPT-4o", "Anthropic Claude 3.5", "Google Gemini 1.5 Pro", "Meta Llama 3 (Local)", "Pinecone", "pgvector", "Qdrant", "Weaviate"]}
    ctaLabel="INTEGRATE AI INTO YOUR SOFTWARE"
  >
    <div style={{ display: "grid", gap: 28 }}>
      <div style={{ background: "#1A1208", border: "1px solid rgba(212,168,67,0.22)", borderRadius: 4, padding: 24, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
        RAG Pipeline: Documents → Chunking & Embedding → Vector DB → Query → Similarity Search → Context Retrieved → LLM → Accurate Answer
      </div>

      <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "28px clamp(20px, 4vw, 30px)" }}>
        <SectionLabel text="USE CASES" />
        <div style={{ overflowX: "auto", marginTop: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 560 }}>
            <thead>
              <tr>
                {["Industry", "Use Case"].map((heading) => (
                  <th key={heading} style={{ textAlign: "left", padding: "14px 0", borderBottom: "1px solid rgba(212,168,67,0.18)", fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, letterSpacing: "0.18em", color: "#D4A843", textTransform: "uppercase" }}>{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {useCases.map((row) => (
                <tr key={row[0]}>
                  {row.map((cell) => (
                    <td key={cell} style={{ padding: "16px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC" }}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      </div>
  </StitchFeaturePage>
);

export default LlmIntegration;
